<template>
    <div class="w-full relative text-gray-300 dark:text-gray-600 cursor-pointer" >
      <!-- Input -->
      <input :disabled="disabled" :id="`select-${label}`" v-model="value" autocomplete="off" :placeholder="placeholder" readonly="true"
      @input="$emit('update:modelValue', $event.target.value); v.$touch()"
      @focus="onFocus = true; giveFocus()" @blur="onFocus = false; clear()"  @keydown.up.prevent="keyUp()" @keydown.down.prevent="keyDown($event)" @keyup.enter.prevent="select()"
      :class="value ? 'text-gray-400 border-gray-400 dark:border-gray-500 dark:text-gray-500' : ''"
      class="w-full block bg-transparent h-10 shadow-sm pl-2 dark:placeholder-gray-600 placeholder-gray-400
      border border-gray-300 dark:border-gray-600 focus:border-transparent rounded-md
      focus:ring-indigo-500 focus:ring-2
      focus:text-gray-500
      disabled:border-0 disabled:shadow-none
      transition-all duration-300 cursor-pointer"/>
        <span v-if="!value" class="material-icons-outlined absolute top-2 left-full -mx-8 select-none">
            keyboard_arrow_down
        </span>
        <span @click="value = ''; $emit('filter')" :class="disabled ? 'hidden': ''" v-else-if="!disableClear" class="material-icons-outlined absolute top-2 left-full -mx-8 select-none">
          clear
        </span>
        <transition name="slide">
        <div id="select-drop" v-if="onFocus" class="absolute z-10 top-full mt-2 bg-gray-100 border border-gray-200 dark:border-gray-700 dark:bg-gray-800 w-full rounded-md py-1 shadow-lg max-h-48 overflow-y-scroll">
            <p class="text-gray-500 px-2 py-2 duration-150 uppercase text-sm" v-if="list.length === 0">Sem opções disponíveis</p>
            <p :id="`drop-${item.id}`" v-for="item in list" @click.stop="click(item.id)"  :key="item.id" :class="(value === item.id) ? ' font-bold text-indigo-500' : (list[selectedIndex].id === item.id) ? 'text-indigo-500' : '' " class="text-gray-500 hover:text-indigo-500 px-2 py-2 transition-colors duration-150 uppercase text-sm p-0.5">{{item[desc]}}</p>
        </div>
        </transition>
      <!-- Label -->
      <label
      :class="onFocus ? 'text-indigo-500 bg-gray-50 dark:bg-gray-900' : value ? 'bg-gray-50 dark:bg-gray-900 text-gray-400 dark:text-gray-500' : ''"
      class="-top-3 absolute px-1 font-bold text-sm bg-gray-50 dark:bg-gray-900 ml-2 transition-all duration-300 select-none">{{label}}</label>

      <!-- Erro -->
      <span v-if="v">
      <span class="text-xs text-red-600 ml-1 transition-all duration-300" v-if="v.$error">{{v.$errors[0].$message}}</span>
      </span>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import Icon from '@/components/Design/Icon'
import { computed } from '@vue/runtime-core'
export default {
    name: 'Select',
    props: ['placeholder', 'modelValue', 'label', 'list', 'validation', 'desc', 'class', 'disabled', 'disableClear'],
    components: {
        Icon
    },
    setup (props, { emit }) {
        const v = props.validation
        const onFocus = ref(false)
        const showPassword = ref(false)

        // Props
        const placeholder = computed(() => {
            return props.placeholder
        })
        const label = computed(() => {
            return props.label
        })
        const value = computed({
            get: () => props.modelValue,
            set: (vl) => emit('update:modelValue', vl)
        })

        // Key Events
        const selectedIndex = ref(0)
        const keyUp = () => {
            const n = props.list.length
            selectedIndex.value = (((selectedIndex.value - 1) % n) + n) % n
            const myElement = document.getElementById(`drop-${props.list[selectedIndex.value].id}`)
            const topPos = myElement.offsetTop
            document.getElementById('select-drop').scrollTo(
                {
                    top: topPos,
                    behavior: 'smooth'
                }
            )
        }
        const keyDown = () => {
            const n = props.list.length
            selectedIndex.value = (((selectedIndex.value + 1) % n) + n) % n
            const myElement = document.getElementById(`drop-${props.list[selectedIndex.value].id}`)
            const topPos = myElement.offsetTop
            document.getElementById('select-drop').scrollTo(
                {
                    top: topPos,
                    behavior: 'smooth'
                }
            )
        }

        const select = () => {
            value.value = props.list.filter(x => x.id === props.list[selectedIndex.value].id)[0][props.desc]
            onFocus.value = false
            document.getElementById(`select-${label.value}`).blur()
            emit('filter')
            if (v) { v.$touch() }
        }
        const click = (index) => {
            value.value = props.list.filter(x => x.id === index)[0][props.desc]
            emit('filter')
            if (v) { v.$touch() }
        }

        // Functions
        const giveFocus = () => {
        }

        const clear = () => {
            if (!props.list.includes(props.modelValue)) { selectedIndex.value = 0 }
        }
        return {
            onFocus,
            placeholder,
            showPassword,
            value,
            label,
            giveFocus,
            selectedIndex,
            keyDown,
            keyUp,
            select,
            clear,
            click,
            v
        }
    }
}
</script>

<style>
.slide-enter-from {
  opacity: 0;
  transform: translateY(-30%);
}
.slide-enter-to {
  opacity: 1;
  transform: translateY(0%);
}

.slide-enter-active {
  transition: all 0.3s ease-in-out;
}

.slide-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-leave-from {
  opacity: 1;
  transform: translateY(0%);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-30%);
}

</style>
